export default __webpack_public_path__ + "static/media/Aboutus_banner.93def0ea.mp4";